import React, { useEffect, useState } from 'react';
import { Collapse, List } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { matchPath, useLocation } from 'react-router-dom';
import { RouteType } from '../types';
import { GetInitInfoQuery, useGetInitInfoQuery } from '../generated/graphql';
import { checkAccess, checkVenueTypeAccess } from '../utils';
import { useUser } from '../utils/hooks/auth';
import ListItemLink from './ListItemLink';

interface SidebarCollapsibleListItemProps {
    route: RouteType;
    onRouteClick: () => void;
    onCollapsibleClick?: () => void;
    isDrawerOpen?: boolean;
}

const SidebarCollapsibleListItem = ({ route, onRouteClick, onCollapsibleClick, isDrawerOpen }: SidebarCollapsibleListItemProps) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const { user: { venueType } } = useUser();
    const [isOpen, setIsOpen] = useState(false);
    const { data } = useGetInitInfoQuery({ fetchPolicy: 'cache-only' });
    const { employeePermissions } = data as GetInitInfoQuery;

    const { childrenRoutes = [] } = route;

    const handleRouteClick = () => {
        setIsOpen(false);
        onRouteClick();
    };

    useEffect(() => {
        if (!isDrawerOpen) {
            setIsOpen(false);
        }
    }, [isDrawerOpen]);


    const parentActive = !!matchPath(pathname, { path: route.path });

    const children = childrenRoutes.map(childRoute => {
        const title = t(...childRoute.title);
        const hasAccess = checkVenueTypeAccess(childRoute.allowedVenueTypes, venueType) &&
            checkAccess(childRoute.permissions, employeePermissions);
        if (!hasAccess) {
            return null;
        }
        const childActive = !!matchPath(pathname, { path: childRoute.path });

        return (
            <ListItemLink
                onClick={handleRouteClick}
                isNested
                active={childActive}
                key={title}
                to={childRoute.path}
                primary={title}
            />
        );
    });

    const mainRouteTitle = t(...route.title);

    return (
        <>
            <ListItemLink
                onClick={() => {
                    setIsOpen(!isOpen);

                    if (onCollapsibleClick) {
                        onCollapsibleClick();
                    }

                }}
                to={route.path}
                isCollapsible
                active={parentActive}
                primary={mainRouteTitle}
                icon={route.icon}
                trailingIcon={isOpen ? ExpandLess : ExpandMore}
            />
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {children}
                </List>
            </Collapse>
        </>
    );
};

export default SidebarCollapsibleListItem;
